import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import UpdateAdmin from './UpdateAdmin';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, admins, newAdmin, error, message, selectedAdmin: admin,
  } = state.admin;
  return {
    isLoading,
    admins,
    newAdmin,
    error,
    message,
    admin,
  };
}

const Styled = withStyles(styles)(UpdateAdmin);

export default connect(
  mapStateToProps,
)(Styled);
